// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"3c33e283","194":"3625818c","233":"8c3b8911","513":"b540e873","703":"24a3e026","787":"3abbbd8c"}[chunkId] + ".chunk.js";
};